import { Chip as MuiChip } from '@mui/material';
import type { ChipProps as MuiChipProps, SxProps } from '@mui/material';
import React from 'react';

import Icon from '@components/Icon/Icon';

interface ChipProps extends Omit<MuiChipProps, 'color'> {
  // MUI color found in MUI theme palette (ex. primary.main)
  color: string;
  // Primary has the color as the bgcolor. Secondary has a bg color of grey and a colored dot
  type?: 'primary' | 'secondary';
}

export default function Chip({ color, type = 'primary', ...props }: ChipProps) {
  let startingIcon:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | undefined;
  let style: SxProps | undefined;

  switch (type) {
    case 'primary':
      style = { color };
      break;
    case 'secondary':
      startingIcon = <Icon color={color} name="circle" type="fas" />;
      break;
  }

  return <MuiChip {...props} icon={startingIcon} sx={{ ...style }} />;
}
